var _circle, _circle2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBreak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#F8F7FF",
    stroke: "url(#paint0_linear_1062_100)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 50,
    r: 22,
    fill: "#393184"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1062_100)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.189 24.3075L23.2391 26.0873L28.4747 30.7924C31.354 33.3811 33.8141 35.3948 33.9412 35.2683C34.2752 34.9356 30.3898 23.7494 29.7093 23.0849C29.3954 22.7785 27.8112 23.328 26.189 24.3075ZM43.9387 28.0238C44.7323 34.2587 45.388 34.4918 46.7056 29.0064L47.9155 23.9717H45.6694H43.4232L43.9387 28.0238ZM71.5416 29.3746C69.3087 32.3461 67.6872 34.7774 67.9384 34.7774C68.1895 34.7774 70.7813 33.3657 73.6978 31.6407L79 28.5032L77.7088 26.2425C76.998 24.999 76.233 23.9794 76.0091 23.9764C75.7851 23.974 73.7746 26.403 71.5416 29.3746ZM54.1307 29.3722C51.1994 34.0418 50.846 35.2058 51.6931 37.4032C52.0729 38.3888 52.7891 38.0978 55.5684 35.8302C59.1918 32.8733 59.5383 31.6229 57.9471 27.2536L57.0333 24.7474L54.1307 29.3722ZM61.286 41.7578C60.3831 43.5192 59.7561 45.0705 59.8925 45.2041C60.0289 45.3384 62.8307 45.759 66.1185 46.1395C72.8995 46.9229 72.9049 46.8735 66.651 41.659L62.9268 38.554L61.286 41.7578ZM23.3973 41.9508C21.589 46.6219 21.5123 47.9039 23.0477 47.8214C23.8398 47.7789 25.2403 47.5188 26.1603 47.2425L27.8329 46.7408L26.0325 43.2675L24.2328 39.7943L23.3973 41.9508ZM33.1638 47.8291L31.2874 52.1436L35.051 52.5295L38.8147 52.9154L37.2755 55.2309C36.4291 56.5045 35.7339 57.8073 35.7316 58.1253C35.7192 59.4598 42.9039 58.6656 45.1315 57.0864L47.4125 55.4687L45.4089 52.0641L43.4046 48.6596L45.5725 47.8175C46.7645 47.3552 48.4371 46.703 49.2897 46.3695C50.4871 45.9003 49.9593 45.6386 46.9645 45.2187C44.8331 44.9193 41.2786 44.4137 39.0651 44.0949L35.041 43.5153L33.1638 47.8291ZM53.1549 54.0624L56.1861 57.1543L58.3811 55.0611C60.921 52.6376 60.5676 52.3512 53.9687 51.4791L50.1228 50.9704L53.1549 54.0624ZM21 53.7151C21 54.0894 27.6353 57.1605 28.4452 57.1605C28.6328 57.1605 28.215 56.2922 27.5167 55.2309C26.5765 53.8015 25.5667 53.3014 23.6236 53.3014C22.1804 53.3014 21 53.4874 21 53.7151ZM47.0939 61.5345C46.8095 61.817 46.577 64.2483 46.577 66.9373V71.8253H51.2273C53.785 71.8253 55.8777 71.6393 55.8777 71.4109C55.8777 71.0404 48.0201 61.0197 47.7295 61.0197C47.6644 61.0197 47.3776 61.2512 47.0939 61.5345ZM59.753 66.2867C59.753 69.5901 59.9863 70.1644 61.4968 70.5673C65.7767 71.7096 66.0263 71.2735 63.4546 67.1527C62.1153 65.007 60.7342 63.0758 60.3862 62.862C60.0382 62.6475 59.753 64.1888 59.753 66.2867ZM35.1394 68.163C32.4778 70.8366 30.3007 73.2949 30.3007 73.6253C30.3007 74.1177 38.1683 78 39.1666 78C39.5898 78 40.6059 65.1783 40.2633 64.1549C40.106 63.6856 37.8002 65.4894 35.1394 68.163Z",
    fill: "url(#paint1_linear_1062_100)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.189 24.3075L23.2391 26.0873L28.4747 30.7924C31.354 33.3811 33.8141 35.3948 33.9412 35.2683C34.2752 34.9356 30.3898 23.7494 29.7093 23.0849C29.3954 22.7785 27.8112 23.328 26.189 24.3075ZM43.9387 28.0238C44.7323 34.2587 45.388 34.4918 46.7056 29.0064L47.9155 23.9717H45.6694H43.4232L43.9387 28.0238ZM71.5416 29.3746C69.3087 32.3461 67.6872 34.7774 67.9384 34.7774C68.1895 34.7774 70.7813 33.3657 73.6978 31.6407L79 28.5032L77.7088 26.2425C76.998 24.999 76.233 23.9794 76.0091 23.9764C75.7851 23.974 73.7746 26.403 71.5416 29.3746ZM54.1307 29.3722C51.1994 34.0418 50.846 35.2058 51.6931 37.4032C52.0729 38.3888 52.7891 38.0978 55.5684 35.8302C59.1918 32.8733 59.5383 31.6229 57.9471 27.2536L57.0333 24.7474L54.1307 29.3722ZM61.286 41.7578C60.3831 43.5192 59.7561 45.0705 59.8925 45.2041C60.0289 45.3384 62.8307 45.759 66.1185 46.1395C72.8995 46.9229 72.9049 46.8735 66.651 41.659L62.9268 38.554L61.286 41.7578ZM23.3973 41.9508C21.589 46.6219 21.5123 47.9039 23.0477 47.8214C23.8398 47.7789 25.2403 47.5188 26.1603 47.2425L27.8329 46.7408L26.0325 43.2675L24.2328 39.7943L23.3973 41.9508ZM33.1638 47.8291L31.2874 52.1436L35.051 52.5295L38.8147 52.9154L37.2755 55.2309C36.4291 56.5045 35.7339 57.8073 35.7316 58.1253C35.7192 59.4598 42.9039 58.6656 45.1315 57.0864L47.4125 55.4687L45.4089 52.0641L43.4046 48.6596L45.5725 47.8175C46.7645 47.3552 48.4371 46.703 49.2897 46.3695C50.4871 45.9003 49.9593 45.6386 46.9645 45.2187C44.8331 44.9193 41.2786 44.4137 39.0651 44.0949L35.041 43.5153L33.1638 47.8291ZM53.1549 54.0624L56.1861 57.1543L58.3811 55.0611C60.921 52.6376 60.5676 52.3512 53.9687 51.4791L50.1228 50.9704L53.1549 54.0624ZM21 53.7151C21 54.0894 27.6353 57.1605 28.4452 57.1605C28.6328 57.1605 28.215 56.2922 27.5167 55.2309C26.5765 53.8015 25.5667 53.3014 23.6236 53.3014C22.1804 53.3014 21 53.4874 21 53.7151ZM47.0939 61.5345C46.8095 61.817 46.577 64.2483 46.577 66.9373V71.8253H51.2273C53.785 71.8253 55.8777 71.6393 55.8777 71.4109C55.8777 71.0404 48.0201 61.0197 47.7295 61.0197C47.6644 61.0197 47.3776 61.2512 47.0939 61.5345ZM59.753 66.2867C59.753 69.5901 59.9863 70.1644 61.4968 70.5673C65.7767 71.7096 66.0263 71.2735 63.4546 67.1527C62.1153 65.007 60.7342 63.0758 60.3862 62.862C60.0382 62.6475 59.753 64.1888 59.753 66.2867ZM35.1394 68.163C32.4778 70.8366 30.3007 73.2949 30.3007 73.6253C30.3007 74.1177 38.1683 78 39.1666 78C39.5898 78 40.6059 65.1783 40.2633 64.1549C40.106 63.6856 37.8002 65.4894 35.1394 68.163Z",
    stroke: "url(#paint2_linear_1062_100)",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1062_100",
    x: 18.85,
    y: 20.85,
    width: 62.3894,
    height: 59.3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1062_100"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1062_100",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1062_100",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DEDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1062_100",
    x1: 27.2066,
    y1: 28.0744,
    x2: 88.361,
    y2: 61.4666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A5FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1062_100",
    x1: 54.8333,
    y1: 32.1667,
    x2: 74.7022,
    y2: 81.0562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1CDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreak);
export default __webpack_public_path__ + "static/media/break.3395416511f6185383ab882d57d246fe.svg";
export { ForwardRef as ReactComponent };